<!-- Card Template 1 -->
<ng-container *ngIf="layout=='custom' || layout=='grid' || layout=='list'">
    <div *ngIf="product?.layout != 'property'" class="card-template-1 item__{{layout}}">
        <div class="flex flex-row main-row ">
            <a class="thumbnail" type="button" appClick [routerLink]="routerLinkString()">
                <div class="img-container">
                    <div class="content">
                        <img [ngClass]="{'image-cover': product?.layout == 'property'}" [src]="image" loading="lazy" [alt]="translateHelper.localize(product?.name)">
                    </div>
                    <div class="product-badges">
                        <!-- <div *ngIf="product?.realEstate?.displayPrice?.propertyType.toLowerCase() =='sale'" class="badge new">{{'for_sale'|translate}}</div>
                        <div *ngIf="product?.realEstate?.displayPrice?.propertyType.toLowerCase() =='rent'" class="badge hot">{{'for_rent'|translate}}</div>
                        <div *ngIf="product?.badges?.includes('new')" class="badge new">{{'new'|translate}}</div>
                        <div *ngIf="product?.badges?.includes('hot')" class="badge hot">{{'hot'|translate}}</div>
                        <div *ngIf="discountedRate" class="badge sale">{{'sale'|translate}} {{discountedRate}}%</div> -->
                    </div>
                </div>
            </a>
            <div class="details">
                <a class="text-csm font-extrabold line-clamp-3 h-16 leading-tight text-black pt-1" type="button"
                    appClick [routerLink]="routerLinkString()">
                    {{translateHelper.localize(product?.name)}}
                </a>
                <div class="caption" *ngIf="translateHelper.localize(product.promotionalCaption)">{{
                    translateHelper.localize(product.promotionalCaption) }}</div>

                <div class="price">
                    <ng-container *ngIf="product?.layout == 'property'; else productPrice">
                        <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'exact'">
                            <span class="current-price">{{product.realEstate?.displayPrice?.price|currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                        </ng-container>
                        <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'range'">
                            <span
                                class="current-price">{{product.realEstate?.displayPrice?.priceRange?.min|currencyConvert : product.companyData?.currencyMeta?.code}} -
                                {{product.realEstate?.displayPrice?.priceRange?.max|currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                        </ng-container>
                        <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'from'">
                            <span class="current-price">
                                {{product.realEstate?.displayPrice?.price|currencyConvert : product.companyData?.currencyMeta?.code}}
                            </span>
                        </ng-container>
                        <small class="font-weight-bold text-capitalize"
                            *ngIf="product?.realEstate?.displayPrice?.propertyType =='rent' && product?.realEstate?.displayPrice?.rentType">
                            / {{product?.realEstate?.displayPrice?.rentType}}
                        </small>
                    </ng-container>
                    <ng-template #productPrice>
                        <ng-container *ngIf="!product?.isOnlyQuotation && !product.isOfferable">
                            <ng-container
                                *ngIf="product?.type == 'service' && (product.pricePerHour ||  product.pricePerDay || product.price); else defaultPriceTemplate">
                                <ng-container *ngIf="!product.hidePrice && !product.timeType">
                                    <span class="current-price">
                                        
                                        <span class="text-black font-extrabold">{{ product.price | currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="product.timeType == 'time_slots'">
                                    <span class="service-price">
                                    
                                        <span class="text-black font-extrabold">{{ product.price | currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                                        <span class="price-comment">/Slot</span>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="product.timeType == 'no_time'">
                                    <span class="service-price">
                                       
                                        <span class="text-black font-extrabold">{{ product.pricePerDay | currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                                        <span class="price-comment">/Day</span>
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="product.timeType == 'time_range'">
                                    <span class="service-price">
                                       
                                        <span class="text-black font-extrabold">{{ product.pricePerHour | currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                                        <span class="price-comment">/Hour</span>
                                    </span>
                                </ng-container>
                            </ng-container>
                            <ng-template #defaultPriceTemplate>
                                <ng-container *ngIf="product.taxedPrice < product.baseTaxedPrice">
                                    <span class="old-price">{{product.baseTaxedPrice ||
                                        product.price|currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                                    <span class="sale-price">{{product.taxedPrice | currencyConvert : product.companyData?.currencyMeta?.code}}</span>{{' '}}
                                </ng-container>
                                <ng-container *ngIf="product.taxedPrice >= product.baseTaxedPrice">
                                    <span class="current-price">
                                        
                                        <span class="text-black font-extrabold">{{ (product.taxedPrice || product.price)
                                            | currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                                    </span>
                                </ng-container>

                                <div *ngIf="product?.type == 'service' && (product.pricePerHour ||  product.pricePerDay || product.price)"
                                    class="prices">

                                </div>
                            </ng-template>

                        </ng-container>
                        <ng-container *ngIf="product?.isOnlyQuotation || product.isOfferable">
                            <div class="in-stock flex flex-row items-center">
                                <img class="me-2" src="assets/svg/tick.svg"> {{'in_stock'|translate}}
                            </div>
                        </ng-container>
                        <div *ngIf="product?.vat == 'I' || product?.vat == 'E'">
                            <span class="text-custom-gray text-cxxs font-medium">{{"inclusive"|translate}}</span>
                        </div>
                        <div *ngIf="canAddToCart && product?.quantity?.min > 1">
                            <span style="color: #eb3545; font-size: 11px;">{{"minimum_quantity"|translate}}:
                                {{product?.quantity?.min}}</span>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
        <div class="actions-row items-center">
            <ng-container *ngIf="canAddToCart && product.layout != 'property' && canShipToUserCountry && !product?.booking?.forBooking; else productViewButton">
                <div class="cart-bar">
                    <app-input-number-new appClick layout="input-2" (addToCart)="addToCart()" aria-label="Quantity"
                        class="product__quantity-availability"
                        [min]="(product.quantity?.min) ? product.quantity?.min : 1" [max]="product.quantity?.max"
                        [step]="product.quantity?.step" [formControl]="amount"></app-input-number-new>

                </div>
            </ng-container>
            <ng-template #productViewButton>
                <div class="cart-bar view-bar-bg items-center">
                    <button class="btn view-btn btn-sm py-1 mobile:w-32 tablet:w-24 desktop:w-32"
                        [ngClass]="{'product-card__addtocart': layout !== 'list', 'product-card__addtocart--list': layout === 'list'}"
                        type="button" appClick [routerLink]="routerLinkString()"
                        [ngClass]="{'btn-loading': addingToCart}">
                        <div class="flex flex-row items-center gap-2">
                            {{"view_item"|translate}}
                            <img class="view_icon"
                                [src]="isRTL?'assets/svg/product-slider/arrow_left.svg':'assets/svg/product-slider/arrow_right.svg'">
                        </div>
                    </button>
                </div>
            </ng-template>

            <div *ngIf="product?.companyData?.name" class="vendor items-center text-center pt-1 place-self-start">
                <a appClick [routerLink]="vendorLink"
                    (click)="scrollToTop()">{{translateHelper.localize(product?.companyData?.name)}} </a>
                <mat-icon class="text-sm" [inline]="true" [fontIcon]="isRTL?'arrow_backward':'arrow_forward'">
                </mat-icon>
            </div>
        </div>
    </div>


    <div *ngIf="product?.layout == 'property' && layout=='grid'" class="card-template-1 property item__grid">

        <div class="flex flex-col h-full">
            <a class="thumbnail-property" type="button" appClick [routerLink]="routerLinkString()">
                <a *ngIf="product?.companyData?.design" appClick [routerLink]="vendorLink"
                    class="vendor-logo ml-auto mb-2 block">
                    <img
                        [src]="product?.companyData?.design?.logo?.thumb?.url || product?.companyData?.design?.logo?.url" [alt]="translateHelper.localize(product?.companyData?.name)"/>
                </a>
                <div class="image-content">
                    <img [ngClass]="{'image-cover': product?.layout == 'property'}" [src]="image" loading="lazy" [alt]="translateHelper.localize(product?.name)">

                </div>
            </a>
            <div class="description flex flex-col py-3 px-4 w-full">
                <a class="property-title text-csm font-extrabold line-clamp-2 leading-tight text-black mb-2" type="button" appClick
                    [routerLink]="routerLinkString()">{{translateHelper.localize(product?.name)}}</a>
                <div class="flex mobile:flex-col sm:flex-row justify-between  mobile:mb-2 sm:mb-4">
                    <div class="price text-cbase ">
                        <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'exact'">
                            <span class="current-price">{{product.realEstate?.displayPrice?.price|currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                        </ng-container>
                        <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'range'">
                            <span class="current-price">{{product.realEstate?.displayPrice?.priceRange?.min|currencyConvert : product.companyData?.currencyMeta?.code}} -
                                {{product.realEstate?.displayPrice?.priceRange?.max|currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                        </ng-container>
                        <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'from'">
                            <span class="current-price">
                                <!-- {{"starting_from"|translate}} -->
                                {{product.realEstate?.displayPrice?.price|currencyConvert : product.companyData?.currencyMeta?.code}}
                            </span>
                        </ng-container>
                        <span class="text-capitalize text-cxs text-custom-gray"
                            *ngIf="product?.realEstate?.displayPrice?.propertyType =='rent' && product?.realEstate?.displayPrice?.rentType">
                            / {{product?.realEstate?.displayPrice?.rentType}}
                        </span>

                    </div>
                    <div class="tag flex flex-row">
                        <div class="text-custom-gray me-1">{{translateHelper.localize(propertyType?.value?.name)}}</div>
                        <div *ngIf="product?.realEstate?.displayPrice?.propertyType.toLowerCase() =='sale'"
                            class="for-sale"> • {{'for_sale'|translate}}</div>
                        <div *ngIf="product?.realEstate?.displayPrice?.propertyType.toLowerCase() =='rent'"
                            class="for-rent"> • {{'for_rent'|translate}}</div>
                    </div>
                </div>





                <div class="flex  flex-col  mt-auto text-black">

                    <div class="flex flex-col mt-auto  cb-property">
                        <!--       <div class="area flex flex-row gap-1 items-center mb-2 mt-3">
                            <ng-container *ngIf="area">

                                <ng-container *ngIf="area.iconImg">
                                    <svg-loader [SVGUrl]='area.iconImg.url'> </svg-loader>
                                </ng-container>
                                <ng-container *ngIf="!area.iconImg">
                                    <mat-icon>{{area.icon}} </mat-icon>
                                </ng-container>
                                {{translateHelper.localize(area.value?.name)}}

                            </ng-container>
                        </div> -->
                        <div class="property-facilities flex flex-wrap gap-3 md:gap-5 ">
                            <ng-container *ngFor="let item of sortBy(this.properties,'pos'); index as i">
                                <ng-container *ngIf="item?.showInListing &&  i < (layout == 'grid'? 3:5)">
                                    <div class="flex flex-row gap-2 items-center">
                                        <ng-container *ngIf="item.iconImg?.url">
                                            <svg-loader [SVGUrl]='item.iconImg.url'> </svg-loader>
                                        </ng-container>
                                        <ng-container *ngIf="!item.iconImg">
                                            <mat-icon class="text-custom-gray">{{item.icon}} </mat-icon>
                                        </ng-container>
                                        <span
                                            class="text-custom-gray text-cxs font-medium leading-none">{{(item.value?.name)?translateHelper.localize(item.value?.name):item.value}}</span>
                                    </div>

                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                    <!--   <div *ngIf="product?.companyData?.name" class="vendor items-center mt-2">

                        <div class="flex flex-row items-center">
                            <div class="flex flex-row items-center">
                                <a class="text-csm agent-name font-normal overflow-hidden text-ellipsis" appClick [routerLink]="vendorLink" (click)="scrollToTop()">{{translateHelper.localize(product?.companyData?.name)}}
                                </a>
                            </div>
                            <mat-icon class="text-sm" [inline]="true" [fontIcon]="isRTL?'arrow_backward':'arrow_forward'"></mat-icon>

                        </div>
                    </div> -->
                </div>

            </div>
        </div>
    </div>

    <div *ngIf="product?.layout == 'property' && layout =='list'" class="card-template-1 property item__list">

        <div class="flex flex-col sm:flex-row h-full">
            <a class="thumbnail-property" type="button" appClick [routerLink]="routerLinkString()">
                <div class="image-content">
                    <img [ngClass]="{'image-cover': product?.layout == 'property'}" [src]="image" loading="lazy" [alt]="translateHelper.localize(product?.name)">

                </div>
            </a>
            <div class="description flex flex-col py-3 px-4 w-full">
                <div class="tag mb-2 flex flex-row">
                    <div class="text-custom-gray me-1">{{translateHelper.localize(propertyType?.value?.name)}}</div>
                    <div *ngIf="product?.realEstate?.displayPrice?.propertyType.toLowerCase() =='sale'"
                        class="for-sale"> • {{'for_sale'|translate}}</div>
                    <div *ngIf="product?.realEstate?.displayPrice?.propertyType.toLowerCase() =='rent'"
                        class="for-rent"> • {{'for_rent'|translate}}</div>
                </div>
                <a class="property-title text-csxl mb-3" type="button" appClick
                    [routerLink]="routerLinkString()">{{translateHelper.localize(product?.name)}}</a>

                <ng-container *ngIf="translateHelper.localize(product.promotionalCaption)">
                    <div *ngIf="layout == 'list'" class="property-caption text-csm text-custom-gray font-normal mb-2">
                        {{ translateHelper.localize(product.promotionalCaption) }}
                    </div>
                </ng-container>

                <div class="price text-csxlx mb-2">
                    <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'exact'">
                        <span class="current-price">{{product.realEstate?.displayPrice?.price|currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                    </ng-container>
                    <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'range'">
                        <span class="current-price">{{product.realEstate?.displayPrice?.priceRange?.min|currencyConvert : product.companyData?.currencyMeta?.code}} -
                            {{product.realEstate?.displayPrice?.priceRange?.max|currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                    </ng-container>
                    <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'from'">
                        <span class="current-price">
                            {{product.realEstate?.displayPrice?.price|currencyConvert : product.companyData?.currencyMeta?.code}}
                        </span>
                    </ng-container>
                    <span class="text-capitalize text-clg text-custom-gray"
                        *ngIf="product?.realEstate?.displayPrice?.propertyType =='rent' && product?.realEstate?.displayPrice?.rentType">
                        / {{product?.realEstate?.displayPrice?.rentType}}
                    </span>

                </div>


                <div class="flex mobile:flex-col sm:flex-row  mt-auto text-black">

                    <div class="flex flex-col mt-auto  cb-property">
                        <div class="area flex flex-row gap-1 items-center mb-3 mt-3">
                            <ng-container *ngIf="area">
                                <ng-container *ngIf="area.iconImg">
                                    <svg-loader [SVGUrl]='area.iconImg.url'> </svg-loader>
                                </ng-container>
                                <ng-container *ngIf="!area.iconImg">
                                    <mat-icon>{{area.icon}} </mat-icon>
                                </ng-container>
                                {{translateHelper.localize(area.value?.name)}}

                            </ng-container>
                        </div>
                        <div class="property-facilities flex flex-wrap gap-3 md:gap-10 ">
                            <ng-container *ngFor="let item of sortBy(this.properties,'pos'); index as i">
                                <ng-container *ngIf="item?.showInListing &&  i < 5">
                                    <div class="flex flex-row gap-2 items-center">
                                        <ng-container *ngIf="item.iconImg?.url">
                                            <svg-loader [SVGUrl]='item.iconImg.url'> </svg-loader>
                                        </ng-container>
                                        <ng-container *ngIf="!item.iconImg">
                                            <mat-icon class="text-custom-gray">{{item.icon}} </mat-icon>
                                        </ng-container>
                                        <span
                                            class="text-custom-gray text-cxs font-medium leading-none">{{(item.value?.name)?translateHelper.localize(item.value?.name):item.value}}</span>
                                    </div>

                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                    <div *ngIf="product?.companyData?.name" class="vendor items-center mt-2"
                        [ngClass]="{'sm:ml-auto vendor-container': layout == 'list'}">
                        <a *ngIf="layout == 'list'" appClick [routerLink]="vendorLink"
                            class="vendor-logo ml-auto mb-2 block">
                            <img
                                [src]="product?.companyData?.design?.logo?.thumb?.url || product?.companyData?.design?.logo?.url" [alt]="translateHelper.localize(product?.companyData?.name)"/>
                        </a>
                        <div class="flex flex-row items-center">
                            <span *ngIf="layout=='list'"
                                class="text-csm font-light text-custom-gray me-2">{{"agent"|translate}}:</span>
                            <a class="text-csm agent-name font-normal overflow-hidden text-ellipsis" appClick
                                [routerLink]="vendorLink" (click)="scrollToTop()">
                                {{translateHelper.localize(product?.companyData?.name)}}
                            </a>
                            <mat-icon class="text-sm ms-2" [inline]="true"
                                [fontIcon]=" isRTL ? 'arrow_backward' : 'arrow_forward'"></mat-icon>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</ng-container>



<!-- Card Template 2 -->
<ng-container *ngIf="layout=='card-2'">
    <div class="card-template-2 rounded-2xl bg-white">
        <div class="flex flex-col h-full">
            <div class="img-container relative shrink-0">
                <div class="flex flex-row text-base mt-3 relative z-10 ">
                    <div class="flex flex-row justify-center items-center img-tag ms-4 bg-black text-white px-4 rounded-full text-center"
                        *ngIf="tag">
                        <img *ngIf="tag.img?.url" [src]="tag.img?.url" class="img-tag-icon me-2">
                        {{translateHelper.localize(tag.title)}}
                    </div>
                    <div class="category-icon text-black ml-auto me-4 rounded-full text-center"
                        *ngIf="product.sector?.productIcon">
                        <img [src]="product.sector?.productIcon.url" class="sector-icon">
                    </div>
                </div>
                <div class="absolute top-0 h-full w-full cursor-pointer" appClick [routerLink]="routerLinkString()">
                    <img class="object-cover h-full w-full rounded-t-2xl" [src]="image" loading="lazy" [alt]="translateHelper.localize(product?.name)">
                </div>
            </div>
            <div class="flex flex-col px-8 py-3 h-full">
                <a class="item-name font-semibold line-clamp-2 leading-tight text-black" type="button" appClick
                    [routerLink]="routerLinkString()">
                    {{translateHelper.localize(product?.name)}}
                </a>
                <div class="flex flex-row mt-3 h-10 items-center">
                    <mat-icon *ngIf="canAddToCart && canShipToUserCountry && !product?.booking?.forBooking" appClick (click)="addToCart()"
                        class="cursor-pointer text-black h-8 w-8" svgIcon="add_to_cart_custom"></mat-icon>
                    <button *ngIf="!canAddToCart || !canShipToUserCountry || product?.booking?.forBooking"
                        class="btn view-btn flex flex-row gap-1 items-center btn-sm py-1 bg-black text-white font-bold"
                        [ngClass]="'product-card__addtocart'" type="button" appClick [routerLink]="routerLinkString()"
                        [ngClass]="{'btn-loading': addingToCart}">
                        {{"view_more"|translate}} <img class="view_icon"
                            [src]="isRTL?'assets/svg/product-slider/arrow_left.svg':'assets/svg/product-slider/arrow_right.svg'">
                    </button>
                    <div class="price-container ms-3 flex flex-col">
                        <ng-container *ngIf="!product?.isOnlyQuotation && !product.isOfferable">
                            <ng-container *ngIf="product.taxedPrice < product.baseTaxedPrice">
                                <span class="current-price"><span class="item-price text-black">{{ product.taxedPrice ||
                                        product.price|currencyConvert : product.companyData?.currencyMeta?.code}}</span></span>
                                <span class="old-price line-through discount-price">{{product.baseTaxedPrice ||
                                    product.price|currencyConvert : product.companyData?.currencyMeta?.code}}</span>
                            </ng-container>
                            <ng-container *ngIf="product.taxedPrice >= product.baseTaxedPrice">
                                <span class="current-price"><span class="item-price text-black">{{ product.taxedPrice ||
                                        product.price|currencyConvert : product.companyData?.currencyMeta?.code}}</span></span>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
                <div *ngIf="product?.companyData?.name" class="mt-auto company-name flex flex-row">
                    <a class="company-name line-clamp-1 break-all text-black" appClick [routerLink]="vendorLink"
                        (click)="scrollToTop()">{{translateHelper.localize(product?.companyData?.name)}} </a>
                    <mat-icon class="text-sm !w-6" [inline]="true" [fontIcon]="isRTL?'arrow_backward':'arrow_forward'">
                    </mat-icon>
                </div>
            </div>

        </div>
    </div>
</ng-container>

<!-- Card Template 3 -->
<ng-container *ngIf="layout=='card-3'">
    <div class="card-template-3 rounded-2xl bg-white p-3">
        <div class="flex mobile:flex-col sm:flex-row h-full">
            <div class="img-container w-56 min-w-40">
                <img class="mobile:object-contain sm:object-cover h-full w-full rounded-2xl" [src]="image"
                    loading="lazy" [alt]="translateHelper.localize(product?.name)">
            </div>
            <div class="flex flex-col sm:ps-4 mobile:px-2  h-full w-full">
                <a class="product-title text-cbase font-semibold sm:line-clamp-3 mobile:line-clamp-1 mt-2 mobile:h-5 sm:mb-4 mobile:mb-3 leading-tight text-black"
                    type="button" appClick [routerLink]="routerLinkString()">
                    {{translateHelper.localize(product?.name)}}
                </a>
                <div class="flex flex-col">

                    <ng-container *ngIf="!product?.isOnlyQuotation && !product.isOfferable">
                        <span class="current-price"><span
                                class="font-extrabold text-black">{{ product.taxedPrice|currencyConvert : product.companyData?.currencyMeta?.code}}</span></span>
                        <!--    <div class="h-3">
                            <ng-container *ngIf="product.taxedPrice < product.baseTaxedPrice">
                                <span class="line-through text-xs text-custom-gray me-1">{{product.baseTaxedPrice ||
                                    product.price|currencyConvert : product.companyData.currencyMeta.code:' '}}</span><span class="text-red-default font-bold font-xs"> {{discountedRate}}% {{'off'|translate}}
                                </span>
                            </ng-container>
                        </div> -->
                    </ng-container>

                    <div class="h-4 mb-1">
                        <div class="vat-text text-cxs font-normal" *ngIf="product?.vat == 'I' || product?.vat == 'E'">
                            {{"inclusive"|translate}}
                        </div>
                    </div>

                    <div class="sm:mt-4 mobile:mt-3">
                        <ng-container *ngIf="canAddToCart && canShipToUserCountry && !product?.booking?.forBooking">
                            <div class="flex flex-row items-center gap-4">
                                <div class="mobile:w-32 tablet:w-24 desktop:w-32">
                                    <app-input-number-new layout="input-3" aria-label="Quantity"
                                        class="product__quantity-availability"
                                        [min]="(product.quantity?.min) ? product.quantity?.min : 1"
                                        [max]="product.quantity?.max" [step]="product.quantity?.step"
                                        [formControl]="amount"></app-input-number-new>
                                </div>

                                <mat-icon appClick (click)="addToCart()" class="text-black cursor-pointer h-8 w-8"
                                    svgIcon="add_to_cart_custom"></mat-icon>
                            </div>
                        </ng-container>

                        <button *ngIf="!canAddToCart || !canShipToUserCountry || product?.booking?.forBooking"
                            class="btn view-btn flex flex-row gap-1 items-center btn-sm py-1 bg-black text-white font-bold"
                            [ngClass]="'product-card__addtocart'" type="button" appClick
                            [routerLink]="routerLinkString()" [ngClass]="{'btn-loading': addingToCart}">
                            {{"view_more"|translate}} <img class="view_icon"
                                [src]="isRTL?'assets/svg/product-slider/arrow_left.svg':'assets/svg/product-slider/arrow_right.svg'">
                        </button>

                    </div>
                </div>


                <div *ngIf="product?.companyData?.name" class="mt-auto text-base flex flex-row">
                    <a class="text-base line-clamp-1 break-all text-black" appClick [routerLink]="vendorLink"
                        (click)="scrollToTop()">{{translateHelper.localize(product?.companyData?.name)}} </a>
                    <mat-icon class="text-sm !w-6" [inline]="true" [fontIcon]="isRTL?'arrow_backward':'arrow_forward'">
                    </mat-icon>
                </div>
            </div>
        </div>
    </div>
</ng-container>
